// HOMEPAGE BANNER COMPONENT

import React from "react"
import IndexCarousel from "./IndexCarousel"
import "../styles/banner.css"
import '../styles/block2.css'
import '../styles/global.css'

export default function IndexBanner(props) {
    
    return(
        
        <div class="container containerWidth">
    
            <div class="row">

                <div class="col-12 col-lg-4">

                    <img class="bannerImg" alt="Welcome to the New Jersey Cybersecurity & Communications Integration Cell" src={props.src}/>
                    <div class="standardText subtitle" dangerouslySetInnerHTML={{ __html: props.subtitle }} />

                </div>

                <div class="col-12 col-lg-8 testCarouselDiv">

                    <IndexCarousel data={props.data} carouselClass="carousel container containerWidth" styles="standardText"/>

                </div>

            </div>
            
        </div>
    
    )
        
}
